import { Middleware, MiddlewareAPI, Dispatch } from "redux";

const thunk: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: any) => {
    if (typeof action === 'function')
        return action(store.dispatch, store.getState)
    return next(action);
}

export default thunk